import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OcrNfcRequest } from '../../../interfaces/OcrInterface/OcrInterface';

interface DniData {
  data: OcrNfcRequest | null;
}

const initialState: DniData = {
  data: null,
};

export const dniSlice = createSlice({
  name: 'dni',
  initialState,
  reducers: {
    saveDniData: (state, action: PayloadAction<OcrNfcRequest>) => {
      state.data = action.payload;
    },
  },
});

export const { saveDniData } = dniSlice.actions;

export default dniSlice.reducer;
